webix.protoUI({
	name:"kanbanheader",
	$kanban:true,
	$skin:function(){
		this.defaults.height = webix.skin.$active.barHeight;
	},
	defaults:{
		icon:"webix_kanban_icon kbi-plus-circle",
		borderless:true,
		template:function(obj){
			return "<div class='webix_kanban_header' style='height:100%; line-height:"+obj.height+"px'>"+
				"<span class='webix_kanban_add_icon webix_icon "+obj.icon+"'></span><span class='webix_strong'>"+obj.label+"</span></div>";
		}
	},
	on_click:{
		webix_kanban_add_icon:function(){
			let obj = { text:"" };
			let kanban = this.getKanban();
			let list = kanban.queryView({id:this.config.link});

			if (list && this.callEvent("onBeforeCardAdd",[obj, list])){
				kanban.setListStatus(obj, list);
				kanban.add(obj);
			}
		}
	},
	getKanban(){
		return webix.$$(this.config.master);
	},
}, webix.ui.label);